<template>
  <v-container>
    <v-card class="pa-6 elevation-2">
      <!-- Header Section -->
      <v-row class="mb-4" justify="space-between" align="center">
        <v-col cols="auto" class="d-flex align-center">
          <v-img :src="tool['工具圖片連結']" max-width="50" max-height="50" class="mr-3" v-if="tool['工具圖片連結']"
            alt="Tool Image"></v-img>
          <h2 class="text-h4 font-weight-bold mb-3">{{ tool['名稱'] }}</h2>
        </v-col>
        <v-col cols="auto" class="d-flex">
          <v-btn :to="`/tool/edit/${tool.Codeno}`" color="primary" outlined class="mr-2">
            編輯
          </v-btn>
          <v-btn color="secondary" outlined @click="goBack">
            返回
          </v-btn>
        </v-col>
      </v-row>

      <!-- Information Sections -->
      <v-row>
        <!-- Basic Information -->
        <v-col cols="12" md="6">
          <v-card class="pa-4 mb-4 elevation-1">
            <v-card-title class="text-h6 font-weight-bold">基本資訊</v-card-title>
            <v-divider class="mb-3"></v-divider>
            <v-simple-table dense>
              <tbody>
                <tr v-for="fieldName in basicFields" :key="fieldName">
                  <td class="font-weight-medium" style="width: 40%;">{{ fieldName }}</td>
                  <td v-html="formatValue(fieldName, tool[getFieldKey(fieldName)])"></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-col>

        <!-- Technical Information -->
        <v-col cols="12" md="6">
          <v-card class="pa-4 mb-4 elevation-1">
            <v-card-title class="text-h6 font-weight-bold">技術細節</v-card-title>
            <v-divider class="mb-3"></v-divider>
            <v-simple-table dense>
              <tbody>
                <tr v-for="fieldName in technicalFields" :key="fieldName">
                  <td class="font-weight-medium" style="width: 40%;">{{ fieldName }}</td>
                  <td v-html="formatValue(fieldName, tool[getFieldKey(fieldName)])"></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <!-- Usage and Assessment -->
        <v-col cols="12">
          <v-card class="pa-4 mb-4 elevation-1">
            <v-card-title class="text-h6 font-weight-bold">使用與評估</v-card-title>
            <v-divider class="mb-3"></v-divider>
            <v-simple-table dense>
              <tbody>
                <tr v-for="fieldName in usageAndAssessmentFields" :key="fieldName">
                  <td class="font-weight-medium" style="width: 40%;">{{ fieldName }}</td>
                  <td v-html="formatValue(fieldName, tool[getFieldKey(fieldName)])"></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>

      <!-- Additional Information -->
      <!-- Additional Information -->
      <v-row>
        <v-col cols="12">
          <v-card class="pa-4 mb-4 elevation-1">
            <v-card-title class="text-h6 font-weight-bold">其他細節</v-card-title>
            <v-divider class="mb-3"></v-divider>
            <v-simple-table dense>
              <tbody>
                <tr v-for="fieldName in additionalFields" :key="fieldName">
                  <!-- 左側欄名 -->
                  <td class="font-weight-medium narrow-column">{{ fieldName }}</td>
                  <!-- 右側內容 -->
                  <td class="expand-column">
                    <span v-html="formatValue(fieldName, tool[getFieldKey(fieldName)])"></span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>

    </v-card>
  </v-container>
</template>


<script>
import axios from "axios";
export default {
  name: "ToolDetails",
  data() {
    return {
      tool: {},
    };
  },
  created() {
    const codeno = this.$route.params.codeno;
    if (codeno) {
      this.fetchToolDetails(codeno);
    } else {
      console.error("未獲取到有效的 codeno");
    }
  },
  computed: {
    basicFields() {
      return ["名稱", "完整名稱", "所屬公司", "官方網址", "產品國籍"];
    },
    technicalFields() {
      return ["程式語言", "技術需求", "使用模型", "使用介面", "是否開源", "工具大分類"];
    },
    usageAndAssessmentFields() {
      return ["推薦度", "使用者喜愛度", "Hugging Face 受歡迎度", "GitHub 受歡迎度", "風險評估"];
    },
    additionalFields() {
      return [
        "功能描述",
        "入門指南",
        "語系",
        "應用場景",
        "最新版本日期",
        "費用",
        "建立時間",
        "審核時間",
        "審核結果",
        "審核退回原因",
        "上架時間",
        "停用時間",
        "異動時間",
        "建立人員",
        "異動人員",
        "Hugging Face ID",
        "GitHub ID",
      ];
    },
  },
  methods: {
    formatValue(fieldName, value) {
      if (fieldName === "入門指南") {
        // 若為陣列形式，逐一列出連結
        if (Array.isArray(value)) {
          return value
            .map(
              (item) =>
                this.isUrl(item)
                  ? `<div><a href="${item}" target="_blank" class="text-primary">${item}</a></div>`
                  : `<div>${item}</div>`
            )
            .join("");
        }

        // 若為逗號分隔的字串，拆分成陣列後處理
        if (typeof value === "string" && value.includes(",")) {
          return value
            .split(",") // 逗號分隔
            .map((item) => item.trim()) // 去除空白
            .map(
              (item) =>
                this.isUrl(item)
                  ? `<div><a href="${item}" target="_blank" class="text-primary">${item}</a></div>`
                  : `<div>${item}</div>`
            )
            .join("");
        }

        // 單一連結或空值
        return this.isUrl(value)
          ? `<a href="${value}" target="_blank" class="text-primary">${value}</a>`
          : value || "";
      }

      // 預設處理其他欄位
      return value === null || value === undefined || value === ""
        ? ""
        : value;
    },

    isUrl(value) {
      const urlPattern = /^(http|https):\/\/[^\s$.?#].[^\s]*$/;
      return urlPattern.test(value);
    },
    async fetchToolDetails(codeno) {
      try {
        const baseUrlo = process.env.VUE_APP_SERVICE_URL;
        const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;
        const response = await axios.get(`${baseUrl}/ToolsDetail/${codeno}`);
        if (response.data.rtnCode === "0000") {
          this.tool = response.data.data;
        } else {
          console.error("無法獲取工具詳細資料:", response.data.rtnMsg);
        }
      } catch (error) {
        console.error("工具詳細資料請求失敗:", error);
      }
    },
    goBack() {
      this.$router.push({ name: "tools" });
    },
    getFieldKey(fieldName) {
      return fieldName; // 直接返回欄名
    },
  },
};
</script>

<style scoped>
.custom-table {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}

th {
  background-color: #f5f5f5;
  font-weight: bold;
  text-align: left;
  padding: 12px;
}

td {
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.text-primary {
  color: #1976d2;
  font-weight: bold;
}

.text-primary:hover {
  text-decoration: underline;
}

.text-h4 {
  font-size: 1.8rem;
  font-weight: bold;
}

.text-h5 {
  font-size: 1.5rem;
  font-weight: bold;
}

.text-h6 {
  font-size: 1.2rem;
}

.text-subtitle-2 {
  font-size: 0.9rem;
}

.pa-4 {
  padding: 16px !important;
}

.pa-6 {
  padding: 24px !important;
}

.mb-4 {
  margin-bottom: 16px !important;
}

.mb-6 {
  margin-bottom: 24px !important;
}

.shadow {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
</style>
